import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector } from '@mews-commander/utils';
import { useAvailabilityBlockStateActions } from '../utils/useAvailabilityBlockStateActions';

interface RevertCancellationButtonProps {
    availabilityBlock: AvailabilityBlock;
}

export const RevertCancellationButton: React.FC<RevertCancellationButtonProps> = ({ availabilityBlock }) => {
    const advancedFeaturesEnabled = useCommanderSelector<boolean>(
        isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled
    );

    const { makeInquired, makeOptional, confirm, dialog } = useAvailabilityBlockStateActions(availabilityBlock);

    return (
        <>
            {dialog}
            <DropDownButton data-revert-cancellation label={<LocalizedText textKey={TextKey.RevertCancelation} />}>
                {advancedFeaturesEnabled && (
                    <>
                        <DropdownItem
                            label={<LocalizedText textKey={TextKey.MakeInquired} />}
                            onClick={makeInquired}
                            data-test-block-make-inquired
                        />
                        <DropdownItem
                            label={<LocalizedText textKey={TextKey.MakeOptional} />}
                            onClick={makeOptional}
                            data-test-block-make-optional
                        />
                    </>
                )}
                <DropdownItem
                    label={<LocalizedText textKey={TextKey.MakeConfirmed} />}
                    onClick={confirm}
                    data-test-block-make-confirmed
                />
            </DropDownButton>
        </>
    );
};
